'use client'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

export type BillingInterval = 'monthly' | 'annual'

interface BillingToggleOption {
  value: BillingInterval
  label: string
  badge?: string
}

const OPTIONS: BillingToggleOption[] = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'annual', label: 'Annual', badge: 'Save 2 months' },
]

interface BillingToggleProps {
  value: BillingInterval
  onChange: (value: BillingInterval) => void
  className?: string
}

export function BillingToggle({ value, onChange, className }: BillingToggleProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Billing interval"
      className={cn('inline-flex items-center rounded-lg bg-muted p-1', className)}
    >
      {OPTIONS.map((option) => {
        const isSelected = value === option.value
        return (
          <button
            key={option.value}
            role="radio"
            aria-checked={isSelected}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'relative inline-flex cursor-pointer items-center gap-2 rounded-md px-4 py-1.5 text-sm font-medium transition-colors duration-200',
              isSelected
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {option.label}
            {option.badge && <Badge variant="primary">{option.badge}</Badge>}
          </button>
        )
      })}
    </div>
  )
}
